import styled from '@mui/material/styles/styled';

export const MapContainer = styled('div')(() => ({
    width: '100%',
    height: '100%',
    '& .ol-viewport': {
        borderRadius: '10px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
}));
